export default (title, linkedin, address, bntLink, btnTarget, btnText, btnFind, findTarget, findText, phone, email) => `

<div class="single-office">
<div class="blured"></div>
    <div class="content">
        <div class="left-side" data-aos-offset="300" data-aos="fade-right">
            <div class="left-side-inner">
                <div class="blured-overlay"><div class="blured-overlay-inner"></div></div>
                <div class="title con">
                    <h2>${title}</h2>
                    ${linkedin ? `<a href="${linkedin}" class="contact-linkedin" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
                            <g id="Group_245" data-name="Group 245"
                               transform="translate(0 0.131)">
                                <g id="Rectangle_108" data-name="Rectangle 108"
                                   transform="translate(0 -0.131)" fill="none" stroke="#e0c084"
                                   stroke-width="1">
                                    <rect width="42" height="42" rx="21" stroke="none"/>
                                    <rect x="0.5" y="0.5" width="41" height="41" rx="20.5"
                                          fill="none"/>
                                </g>
                                <g id="linkedin_2_" data-name="linkedin (2)"
                                   transform="translate(14.477 14.553)">
                                    <path id="Path_93" data-name="Path 93"
                                          d="M17.206,16.809h0V11.86c0-2.421-.521-4.286-3.351-4.286a2.938,2.938,0,0,0-2.646,1.454h-.039V7.8H8.489v9.008h2.794V12.348c0-1.174.223-2.31,1.677-2.31,1.433,0,1.454,1.34,1.454,2.385v4.386Z"
                                          transform="translate(-3.716 -3.316)" fill="#e0c084"/>
                                    <path id="Path_94" data-name="Path 94"
                                          d="M.4,7.977h2.8v9.008H.4Z"
                                          transform="translate(-0.173 -3.492)" fill="#e0c084"/>
                                    <path id="Path_95" data-name="Path 95"
                                          d="M1.62,0a1.628,1.628,0,1,0,1.62,1.62A1.621,1.621,0,0,0,1.62,0Z"
                                          transform="translate(0 0)" fill="#e0c084"/>
                                </g>
                            </g>
                        </svg>
                    </a>` : ''}
                </div>
            </div>
    
            <div class="right-side-inner">
                <div class="single-info">
                    <div class="title">
                        <p>${address}</p>
                    </div>
                    <div class="btns-c">
                        ${bntLink ? ` <div class="btn-stroke">
                            <a href="${bntLink}" target="${btnTarget}">${btnText}</a>
                        </div>` : ''}
                         ${btnFind ? ` <div class="btn-stroke">
                            <a href="${btnFind}" target="${findTarget}">${findText}</a>
                        </div>` : ''}
                     </div>
                    <div class="contacts-info">
                        <div class="single-contact-info">
                            <a href="telto:${phone}">${phone}</a>
                        </div>
                        <div class="single-contact-info">
                            <a href="mailto:${email}">${email}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

`